<template>
    <v-container>
        <div class="custom_course-info mb-10">   
            <v-toolbar flat>
                <v-card-actions>
                    <v-icon @click="backToCourses" color="secondary"  style="margin-right: 10px">
                        mdi-arrow-left-thick
                    </v-icon>
                </v-card-actions>
            <v-toolbar-title style=""><b>{{course.courseId}}</b></v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card class="mb-5 pa-3 course-info_div" dense>
                <v-row>
                    <v-switch
                        v-model="course.courseStatus"
                        class="mt-0 mr-1 ml-4" 
                        color="blue"
                        inset
                        dense
                        @change="saveCourseStatus()"
                        :label="course.courseStatus?'Active':'Inactive'"
                   >
                    </v-switch>

                     <v-switch
                        v-model="course.isPaid"
                        class="mt-0 mr-1 ml-4" 
                        color="blue"
                        inset
                        dense
                        @change="saveCoursePaidStatus()"
                        :label="course.isPaid ?'Paid':'Free'"
                   >
                    </v-switch>
                    <v-spacer></v-spacer>

                    <div class="px-4">
                        <v-card-actions>
                            <v-btn
                                class="btn_custom-color"
                                :disabled="disabled"
                                type="submit"
                                @click="saveCourseInfo"
                            >
                                SAVE CHANGES
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-row>
            
                <v-divider></v-divider>
                <v-dialog persistent v-model="editTextDialog" width="900" height="800">
                    <EditText :editedText="toBeEditedText" @changeEditedText="changeEditedText($event)"/>
                </v-dialog>
                <v-row no-gutters  dense class="mt-5">
                    <v-col cols="2">
                        <v-card-text class="mt-2"
                            >Title
                        </v-card-text>  
                    </v-col>
                    <v-col cols="4" >
                        <v-text-field class="my-2"
                            v-model="course.courseTitle"
                            outlined
                            dense
                            @click="editTextTitle($event)"
                            :rules="courseTitleRules"
                            :success="courseTitleSuccess"
                        ></v-text-field>

                    </v-col>
                </v-row>
                
                <v-row no-gutters  dense >
                    <v-col cols="2">
                        <v-card-text
                            >Description
                        </v-card-text>  
                    </v-col>
                    <v-col cols="4" >
                        <v-text-field class="mb-2"
                            v-model="course.courseDescription"
                            outlined
                            dense
                            @click="editTextDescription($event)"
                            :rules="courseDescriptionRules"
                            :success="courseDescriptionSuccess"
                        ></v-text-field>
                    </v-col>
                </v-row>
            <v-row v-if="errorMessage || successMessage">
                <v-col cols="6" offset-md="2">
                    <v-alert v-if="errorMessage" type="error">
                        {{errorMessage}}
                    </v-alert>
                    <v-alert v-if="successMessage" type="success">
                        {{successMessage}}
                    </v-alert>
                </v-col>
            </v-row>  
        </v-card>
    <v-toolbar flat>
        <v-toolbar-title style=""><b>Lessons</b></v-toolbar-title>
            <v-spacer></v-spacer>
            <router-link 
                to="/admin/modifylessons"
                style="text-decoration:none;" >
                <v-btn color="secondary">
                    Modify Lesson List
                </v-btn>
            </router-link>
        </v-toolbar>
        <v-card class="pa-2 custom-bg_course">
            <v-row class="pa-2" no-gutters>
                <v-spacer></v-spacer>
                    <div class="mr-3" v-if="!noData">
                        Search:
                    </div>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            prepend="search"
                            v-if="!noData"
                            type="text"
                            dense
                            v-model="search"
                            single-line
                            hide-details
                            outlined
                            no-gutters
                            height="32"
                            style="font-size: 14px"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                    class="ma-2 custom-course-table"
                    outlined
                    dense
                    fixed-header
                    :headers="headers"
                    :items="lessonList"
                    :items-per-page="10"
                    sort-by="['serialNum','LessonId','lessonTitle', 'lessonDescription','lessonStatus']"
                    :hide-default-footer="noData"
                    :search="search"
                    :hide-default-header="noData"
                    no-data-text="No Data Available"
                    no-result-text="No Data Found"
                >

                <template v-slot:item.serialNum="{item}">
                    {{lessonList.indexOf(item)+1}} 
                </template>
                <template v-slot:item.lessonStatus="{item}">
                    <v-switch
                        v-model="item.lessonStatus"
                        class="mt-0 mr-1" 
                        color="blue"
                        inset
                        dense
                        @change="saveLessonStatus(item._id, item.lessonStatus, lessonList.indexOf(item))"
                        :label="item.lessonStatus?'Active':'Inactive'"
                    >
                    <!-- @change="saveLessonStatus(item._id, item.lessonStatus)" -->
                    </v-switch>
                </template>
                <template v-slot:item.viewDetail ="{item}"> 
                    <router-link :to="'/admin/lessoninfo/'+item._id" style="text-decoration:none;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <v-icon
                                    class="mr-2"
                                    color="blue darken-3"
                                    v-on="on"
                                    >mdi-eye
                                </v-icon> 
                            </template>
                            <span>View Details</span>
                        </v-tooltip>
                    </router-link>
                </template>
            </v-data-table>  

            <v-row v-if="errorMessageLesson || successMessageLesson">
                <v-col cols="6" offset-md="2">
                    <v-alert v-if="errorMessageLesson" type="error">
                        {{errorMessageLesson}}
                    </v-alert>
                    <v-alert v-if="successMessageLesson" type="success">
                        {{successMessageLesson}}
                    </v-alert>
                </v-col>
            </v-row>  
        </v-card>
    </div>
  </v-container>
</template>

<script>

import Course from "../../models/Course.js";
import CourseLessonMapping from '../../models/CourseLessonMapping.js';
import EditText from "../../components/admin/EditText";
import { mapMutations } from "vuex";
//import Lesson from "../../models/Lesson.js";
export default {
   
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) 
                    {
                        vm.$router.push("/");
                    }  
            }, 0);
        });
    },

    name: "CourseInfoEdit",
    components: {
        EditText
    },
    data() {
        return {
            disabled:false,
            toBeEditedText:'',
            editTextDialog:false,
            textField:null,
            inputType: '',
            //courseId:this.course_id,
            course_id:this.$store.state.course._id,
            successMessageLesson:'',
            errorMessageLesson:'',
            headers:
            [
            {text:'S.No', value:'serialNum'},
            {text:'Id', value:'lessonId'},
            {text:'Title', value:'lessonTitle'},
            {text:'Description', value:'lessonDescription'},
            {text:'Status', value:'lessonStatus'},
            {text:'', value:'viewDetail'},
            ],
            search:'',
            course:new Course(),
            errorMessage: "",
            successMessage:'',
            border:true,
            dataLoaded:false,
            lessonList:[],
            noData:false,
            courseTitleSuccess: false,
                courseTitleRules: [
                v => {
                    if (v)
                    {
                        this.courseTitleSuccess = true;
                        return true;
                    } else {
                        this.courseTitleSuccess = false;
                        return "Title is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Title must be at least 2 characters long",
                v =>
                    (v || "").length <= 30||
                    "Title must be less than 30 characters"//30
            ],

            courseDescriptionSuccess:false,
            courseDescriptionRules: [
                v => {
                    if (v) {
                        this.courseDescriptionSuccess = true;
                        return true;
                    } else {
                        this.courseDescriptionSuccess = false;
                        return "Description is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Description be at least 2 characters long",
                v =>
                    (v || "").length <= 80 ||
                    "Description must be less than 80 characters"//255
            ],
            
            };
    },
    methods: 
    { 
        ...mapMutations(["removeCourse"]),
        getCourseInfo() { 
            Course.getCourseById( this.course_id, this.auth.token)
                .then(res => {
                    //console.log("res get course info", res);
                    this.course=res.data;
                    console.log('coueseINFO', this.course);
                })
                .catch(err => console.error(err.response.data));    
        },

        saveCourseInfo(){
            this.disabled=true;

            if (this.course.courseTitle.length<2 ||this.course.courseTitle.length>30)//30
                {
                    this.errorMessage = 'Title should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }
            
            if (this.course.courseDescription.length<2 ||this.course.courseDescription.length>80)//255
                {
                    this.errorMessage = 'Description should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }

            let course={courseTitle:this.course.courseTitle, courseDescription:this.course.courseDescription }; 
            Course.saveCourse(this.course._id, course, this.auth.token).then(res=>{
                console.log(res);
                this.disabled=false;
                this.successMessage = 'Course updated successfully';
                setTimeout(() => (this.successMessage = ""), 5000);
            }).catch(err=>{
                console.error('error', err);
            })
        },

        getLessons() {
             CourseLessonMapping.getExistingLessonsOfACourse(this.course_id, this.auth.token)
                .then(res => { 
                   console.log("res lesson", res);
                   this.lessonList = res.data;
                    if(res.data.length==0)
                        this.noData=true;
                    })
                .catch(err => console.error(err.response.data));   
            },
            
        saveCourseStatus(){
            Course.putCourseStatus(this.course._id, this.course.courseStatus, this.auth.token)
                .then(res=>{
                    console.log('res', res.data);
                    })
                .catch(err => console.error(err.response.data));
            },


        saveCoursePaidStatus(){
            Course.putCoursePaidStatus(this.course._id, this.course.isPaid, this.auth.token)
                .then(res=>{
                    console.log('res', res.data);
                    })
                .catch(err => console.error(err.response.data));
            },


        saveLessonStatus(lesson_id, status,index){
            CourseLessonMapping.putLessonStatusByCourse(this.course_id, lesson_id, status, this.auth.token).then(res=>{//(this.auth.token)
                console.log('res', res.data);
            }).catch(err => { this.errorMessageLesson = err.response.data;
                    setTimeout(() => (this.errorMessageLesson = ""), 5000);
                    this.lessonList[index].lessonStatus=false});
        },        

       backToCourses(){
           this.removeCourse();
           this.$router.replace('/admin/courses');
       },

       editTextTitle(e)
       {
            this.textField=e.target;
            this.textField.blur();
            this.inputType="title"
            this.toBeEditedText=this.course.courseTitle;
            this.editTextDialog=true;
        },

        editTextDescription(e){
            this.textField=e.target;
            this.textField.blur();
            this.inputType="desc"
            this.toBeEditedText=this.course.courseDescription;           
            this.editTextDialog=true;
        },

        changeEditedText(editedText) {
            if(editedText===null)
            {
                this.editTextDialog=false;
            }
            else
            {
                //console.log("Selected: "+ this.inputType );
                this.toBeEditedText=editedText;
                if(this.inputType == 'title')
                {
                    this.course.courseTitle = editedText;
                }
                else  if(this.inputType == 'desc') {
                    this.course.courseDescription = editedText; 
                }
            }
            this.editTextDialog = false;
        }
    },
    computed:{

        auth() {
            return this.$store.state.auth;
        }
    },    

    mounted() {
        this.getCourseInfo();
        this.getLessons();
    }
 }

</script>
<style scoped>
.custom_course-info >>> header {
    background: transparent !important;
}
.custom_course-info >>> header .v-toolbar__content {
    padding: 0;
}
.course-info_div {
    padding-top: 15px;
    border-top: 3px solid #1b73ba;
}
.custom_course-info >>> .v-card__text {
    padding: 10px 16px;
}
.custom_course-info >>> .v-data-table-header__icon {
    margin-left: 10px;
}
.custom_course-info >>> .v-data-table-header > tr > th {
    font-size: 14px;
}
.custom_course-info >>> .v-data-footer {
    margin: 0;
    font-size: 14px;
}
.custom-bg_course {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
.custom-course-table {
    border-radius: 0 !important;
}
.custom_course-info >>> .v-input__slot.Blue .mdi-menu-down,
.custom_course-info >>> .v-input__slot.oramge .mdi-menu-down,
.custom_course-info >>> .v-input__slot.green .mdi-menu-down {
    color: #fff !important;
}
.custom_course-info >>> .v-input__slot {
    min-height: 32px !important;
}
.custom_course-info >>> .v-data-footer {
    margin: 0;
    font-size: 14px;
    border:0!important;
}
.custom_course-info >>> .v-input__slot {
    min-height: 32px !important;
}
.custom_course-info >>> table{
    border-radius: 0;
    border-collapse: collapse;
    border:0!important;
}
.custom_course-info >>> table tr td,
.custom_course-info >>> table tr th {
    border: 1px solid rgba(0, 0, 0, 0.12)!important;
    box-shadow: none!important;
}
.custom_course-info >>> .v-data-table__wrapper table  tbody > tr > td:last-child,
.custom_course-info >>> .v-data-table__wrapper table  thead > tr > th:last-child{
    text-align: center!important;
}
.custom_course-info >>>  table .v-input .v-input__slot, .custom_course-info >>>  table .v-chip{
    width: 160px;
    padding: 0 15px;
}
.custom_course-info >>>  table .v-input .v-input__slot .v-icon{
    top:-3px;
}
</style>

